import { HammerGestureConfig } from '@angular/platform-browser';
import { Injectable } from "@angular/core";

declare var Hammer: any;

@Injectable()
export class HammerConfig extends HammerGestureConfig {
    overrides = <any>{
        press: { time: 750 },
    };

    buildHammer(element: HTMLElement) {
        return new Hammer(element, {
            touchAction: 'pan-y',
        });
    }
}
